<template>
  <v-data-table
    class="t-catalog-document-list mt-3"
    v-if="_currentDocument.name"
    :headers="documentTypesList[_currentDocument.name].headers"
    :items="_records"
    :pagination.sync="pagination"
    item-key="nomenklatura_id"
    hide-actions
    hide-headers
  >
    <template slot="items" slot-scope="props">
      <tr style="border-bottom: 0">
        <td colspan="3">
          <span class="accent--text">{{ props.item.nomenklatura_id}}</span> {{ props.item.name}}
        </td>
      </tr>
      <tr>
        <td class="text-xs-right" style="text-align: right">
          <input
            v-model.number="props.item.kolichestvo"
            @focus="$event.target.select()"
            @change="_refreshItemsTableQuantity"
            type="number"
            min="1"
            v-numericOnly
            pattern="\d*"
            class="table-qty">
        </td>
        <td class="text-xs-right" v-if="props.item.rezerv">{{ props.item.rezerv }} * {{ props.item.tsena }} = {{ (props.item.tsena *
          props.item.rezerv) | numberFormat(2, '.', ' ') }}
        </td>
        <td class="text-xs-right" v-else>
          {{ props.item.tsena }}
        </td>
        <td class="text-xs-left">
          <v-tooltip bottom>
            <v-icon
              slot="activator"
              color="red"
              @click="deleteRow(props.item)"
            >
              mdi-delete
            </v-icon>
            <span>Удалить</span>
          </v-tooltip>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <empty-table
        :emptyText="'В документе нет товаров'"
      />
    </template>
    <template slot="footer">
      <td colspan="1">
      </td>
      <td class="text-xs-right"><strong>{{ documentSummaCurrent | numberFormat(2, '.', ' ') }}</strong></td>
      <td></td>
    </template>
  </v-data-table>
</template>

<script>
import emptyTable from '@/components/helpers/EmptyTable'
import { mapGetters, mapActions } from 'vuex'
import { mapMultiRowFields } from 'vuex-map-fields'
import { numericOnly } from '@/directives/numericOnly'
import numberFormat from '@/filters/numberFormat'

export default {
  name: 'CatalogDocumentList',
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  props: {
    documentTypes: {
      default: () => {},
      required: false,
      type: Object
    }
  },
  components: {
    emptyTable
  },
  data () {
    return {
      pagination: {
        sortBy: 'name',
        rowsPerPage: -1
      },
      documentTypesList: {
        rezervirovanie: {
          headers: [
            {
              text: 'К-во',
              align: 'right',
              value: 'kolichestvo'
            },
            {
              text: 'Резерв',
              align: 'right',
              value: 'rezerv'
            },
            {
              text: 'Цена',
              align: 'right',
              value: 'tsena'
            },
            {
              text: 'Текущая сумма',
              align: 'right',
              value: 'summa'
            },
            {
              text: '',
              align: 'center',
              width: '45px',
              value: 'actions',
              sortable: false
            }
          ]
        },
        schet: {
          headers: [
            {
              text: 'К-во',
              align: 'right',
              value: 'kolichestvo'
            },
            {
              text: 'Резерв',
              align: 'right',
              value: 'rezerv'
            },
            {
              text: 'Цена с НДС',
              align: 'right',
              value: 'tsena'
            },
            {
              text: 'Текущая сумма',
              align: 'right',
              value: 'summa'
            },
            {
              text: '',
              align: 'center',
              width: '45px',
              value: 'actions',
              sortable: false
            }
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _currentDocument: 'currentDocument'
    }),
    ...mapMultiRowFields('catalog', {
      _records: 'currentDocument.records'
    }),
    documentSummaCurrent () {
      let summa = 0
      if (this._currentDocument.records) {
        this._currentDocument.records.forEach(function (v) {
          if (v.tsena && v.rezerv) {
            summa += parseFloat(v.tsena) * parseInt(v.rezerv)
          }
        })
      }
      return summa
    }
  },
  methods: {
    ...mapActions('catalog', {
      _deleteRow: 'deleteRow',
      _refreshItemsTableQuantity: 'refreshItemsTableQuantity'
    }),
    deleteRow (item) {
      this._deleteRow(item)
      this._refreshItemsTableQuantity()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .t-catalog-document-list {
    .column {
      padding-left 16px !important
      padding-right 16px !important
    }

    tbody td {
      padding-left 16px !important
      padding-right 16px !important
    }

    tfoot td {
      padding-left 16px !important
      padding-right 16px !important
    }
  }
</style>
